'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _PubSub = require('./PubSub');

var _PubSub2 = _interopRequireDefault(_PubSub);

var _Logger = require('./Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _level = require('./level');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KennyLoggins = function () {
	function KennyLoggins() {
		var debugMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

		_classCallCheck(this, KennyLoggins);

		this.debugMode = debugMode;

		this.pubsub = new _PubSub2.default();

		this.loggers = [];

		this.formatters = {};

		this.configs = [];

		this.globals = {};

		this.defaultLogger = _Logger2.default.createLogger({
			name: 'default',
			level: _level.Level.ERROR,
			callback: function callback() {}
		});
	}

	/**
  * Takes an array of configuration objects and creates loggers for each one.
  * Order of configurations matter as the first matching configuration is
  * returned when doing getLogger().
  *
  * Example Config:
  * [{
  * 		name: 'common.services.orders'
  * 		appenders: [new ConsoleAppender(), new AjaxAppender()]
  * 	},
  * 	{
  * 		name: '^common'
  * 		appenders: [new ConsoleAppender()]
  * }]
  *
  * @param config
  * @returns {KennyLoggins}
     */


	_createClass(KennyLoggins, [{
		key: 'configure',
		value: function configure(config) {
			if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
				return this;
			}

			this.setFormatters(config.formatters);

			this.setGlobals(config.globals);

			if (config.loggers) {
				this.setLoggerConfigs(config.loggers);
			} else if (config.appenders) {
				console.log('The .configure({ appenders: [] }) syntax is now deprecated. Please switch to .configure({ loggers: [] }) in the future.');
				this.setLoggerConfigs(config.appenders);
			}
			return this;
		}
	}, {
		key: 'setFormatters',
		value: function setFormatters(formatters) {
			var _this = this;

			if (!Array.isArray(formatters)) {
				return;
			}

			formatters.forEach(function (formatter) {
				var name = (0, _helpers.isString)(formatter.name) || '[ UNKNOWN ]';
				if ((0, _helpers.isObject)(formatter) && (0, _helpers.isString)(formatter.name) && (0, _helpers.isFunction)(formatter.format)) {
					_this.formatters[formatter.name] = formatter.format;
				} else {
					console.warn('Invalid formatter configuration for formatter ' + name + '. Expecting: "{ name: [field name], format: [format function] }".');
				}
			});
		}
	}, {
		key: 'setLoggerConfigs',
		value: function setLoggerConfigs(configs) {
			var _this2 = this;

			if (!Array.isArray(configs)) {
				return;
			}
			configs.forEach(function (config) {
				if (config.name) {
					_this2.configs.push(config);
				} else {
					console.warn('Invalid logger configuration name found. This configuration will be ignored.', config);
				}
			});
		}
	}, {
		key: 'setGlobals',
		value: function setGlobals(globals) {
			if (!globals) {
				return;
			}

			this.globals = globals;
		}

		/**
   * Loops through array of appenders, subscribes them to the logger
   * @param {string} logger - Name of logger to set appenders to listen
   * @param {Object} appenders - Object that contains an array of appenders
   * @returns {KennyLoggins} returns self to allow for chaining
   */

	}, {
		key: 'configureAppenders',
		value: function configureAppenders(logger, appenders) {
			var _this3 = this;

			if (!Array.isArray(appenders)) {
				return this;
			}

			appenders.forEach(function (appender) {
				if ((typeof appender === 'undefined' ? 'undefined' : _typeof(appender)) === 'object' && typeof appender.onLogEventHandler === 'function') {
					_this3.pubsub.subscribe(logger, function (logger, event) {
						return appender.onLogEventHandler(logger, event);
					});
				}
			});
		}

		/**
   * Get a logger instance if it exists or create a new one.
   * Returns a default logger if no configuration is found.
   * @param  {String} name of logger config to use.
   * @return {Logger} instance of a logger
   */

	}, {
		key: 'getLogger',
		value: function getLogger(name) {
			try {
				var logger = this.getLoggerByName(name);

				if (logger) {
					return logger.logger;
				}

				var config = this.getLoggerConfig(name);

				if (config) {
					return this.createLogger(_extends(config, { name: name }));
				}

				return this.defaultLogger;
			} catch (err) {
				console.log(err);
				return this.getDefaultLogger();
			}
		}

		/**
   * Function for creating new loggers. Adds new logger to list of logger instances.
   * @param {object} config
  	 * @returns {Logger}
      */

	}, {
		key: 'createLogger',
		value: function createLogger(config) {
			var _this4 = this;

			config.callback = function (param) {
				return _this4.pubsub.publish(config.name, param);
			};

			var logger = _Logger2.default.createLogger(_extends(config, { formatters: this.formatters, globals: this.globals }));
			this.configureAppenders(config.name, config.appenders);

			if (!this.debugMode) {
				// FIXME: this is messing with logger callback scoping when enabled
				// safetyWrapper(logger);
			}

			this.loggers.push({ name: config.name, logger: logger });

			return logger;
		}
	}, {
		key: 'getDefaultLogger',
		value: function getDefaultLogger() {
			return this.getLoggerByName('default');
		}
	}, {
		key: 'getLoggerConfig',
		value: function getLoggerConfig(name) {
			var isFound = false;
			var config = void 0;

			if (this.configs.length === 0 || !name) {
				return config;
			}

			this.configs.forEach(function (c) {
				if (!isFound && (0, _helpers.isRegexMatch)(c.name, name)) {
					isFound = true;
					config = (0, _lodash2.default)(c);
				}
			});

			return config;
		}
	}, {
		key: 'getLoggerByName',
		value: function getLoggerByName(name) {
			var logger = void 0;

			this.loggers.forEach(function (l) {
				if (l.name === name) {
					logger = l;
				}
			});

			return logger;
		}
	}]);

	return KennyLoggins;
}();

exports.default = KennyLoggins;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/KennyLoggins.js
// module id = 754
// module chunks = 0